import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SalaEspera from "./index";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

const SalaEsperaShort = () => {
  const { code } = useParams();
  const [resolved, setResolved] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/public/s/${code}`)
      .then(res => setResolved(res.data))
      .catch(() => setError(i18n.t("salaEspera.linkNoEncontrado")));
  }, [code]);

  if (error) {
    return (
      <div style={{ padding: 32, textAlign: "center", color: "#f85149", fontSize: "1.2rem" }}>
        {error}
      </div>
    );
  }

  if (!resolved) {
    return (
      <div style={{ padding: 32, textAlign: "center", color: "#8b949e" }}>
        {i18n.t("salaEspera.cargando")}
      </div>
    );
  }

  return (
    <SalaEspera
      companySlug={resolved.companySlug}
      roomSlug={resolved.roomSlug}
      language={resolved.language}
    />
  );
};

export default SalaEsperaShort;
